export default {
      id: "uspcard-returnOfPremium-usage",
      viewBox: "0 0 200 52",
      url: __webpack_public_path__ + "sprite.svg#uspcard-returnOfPremium",
      toString: function () {
        return this.url;
      }
    }